import { render, staticRenderFns } from "./DoctorCard.vue?vue&type=template&id=480c04fc&scoped=true&"
import script from "./DoctorCard.vue?vue&type=script&lang=js&"
export * from "./DoctorCard.vue?vue&type=script&lang=js&"
import style0 from "./DoctorCard.vue?vue&type=style&index=0&id=480c04fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c04fc",
  null
  
)

export default component.exports